import data from "../../.sourceflow/leaders.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const leaders_helper = new CollectionHelper(data);
